import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Label,
  Button,
  FormGroup,
  Input,
  Form,
  Alert,
} from 'reactstrap';
import Select from 'react-select';
import { getUserId, hasRole } from '../../services/authService';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as timeCardEntryActions from '../../actions/timeCardEntryActions';
import moment from 'moment';

class TimeCardEntryInlineForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entryDate: '',
      entryType: '',
      timeIn: '',
      timeOut: '',
      errors: {},
    };
  }

  formIsValid() {
    let errors = {};
    let isValid = true;

    if (this.state.entryDate === null) {
      errors.entryDate = 'Select a date.';
      isValid = false;
    }
    if (this.state.entryType === null) {
      errors.entryType = 'Select entry type.';
      isValid = false;
    }
    if (this.state.timeIn === null) {
      errors.timeIn = 'Enter time in.';
      isValid = false;
    }
    if (this.state.timeOut === null) {
      errors.timeOut = 'Enter time out.';
      isValid = false;
    }

    this.setState({ errors: errors });
    return isValid;
  }

  saveEntry = (event) => {
    event.preventDefault();
    if (!this.formIsValid) return;
    let entry = {};
    entry.cardId = this.props.cardId;
    entry.entryDate = moment(this.state.entryDate).format('YYYY-MM-DD');
    entry.entryType = this.state.entryType;
    entry.timeIn = entry.entryDate + 'T' + this.state.timeIn + ':00';
    entry.timeOut = entry.entryDate + 'T' + this.state.timeOut + ':00';
    entry.userId = hasRole('ROLE_MANAGER') ? this.props.userId : getUserId();
    this.props.saveTimeEntry(entry);
    this.clearForm();
  };

  clearForm = () => {
    this.setState({
      entryDate: '',
      entryType: '',
      timeIn: '',
      timeOut: '',
      error: {},
    });
  };

  render() {
    const { saving, errors } = this.state;
    return (
      <Col md={12}>
        <Form className="m-4">
          <Row>
            <Col md={3}>
              <FormGroup>
                <Label for="entryDate">Date</Label>
                <Input
                  type="date"
                  name="entryDate"
                  id="entryDate"
                  value={this.state.entryDate}
                  onChange={(event) => {
                    this.setState({ entryDate: event.target.value });
                  }}
                />
                {errors.entryDate && (
                  <Alert className="mt-2 p-2" color={'danger'}>
                    {errors.entryDate}
                  </Alert>
                )}
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for="entryType">Entry Type</Label>
                <Select
                  name="entryType"
                  id="entryType"
                  value={this.state.entryType}
                  onChange={(selectedOption) => {
                    this.setState({ entryType: selectedOption.value });
                  }}
                  options={[
                    { value: 'Work', label: 'Work' },
                    { value: 'Sick', label: 'Sick' },
                    { value: 'Holiday', label: 'Holiday' },
                    { value: 'Paid Time Off', label: 'Paid Time Off' },
                    { value: 'Unpaid Time Off', label: 'Unpaid' },
                  ]}
                />
                {errors.entryDate && (
                  <Alert className="mt-2 p-2" color={'danger'}>
                    {errors.entryDate}
                  </Alert>
                )}
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label for="timeIn">Time In</Label>
                <Input
                  type="time"
                  name="timeIn"
                  id="timeIn"
                  value={this.state.timeIn}
                  onChange={(event) => {
                    this.setState({ timeIn: event.target.value });
                  }}
                />
                {errors.timeIn && (
                  <Alert className="mt-2 p-2" color={'danger'}>
                    {errors.timeIn}
                  </Alert>
                )}
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label for="timeOut">Time Out</Label>
                <Input
                  type="time"
                  name="timeOut"
                  id="timeOut"
                  value={this.state.timeOut}
                  onChange={(event) => {
                    this.setState({ timeOut: event.target.value });
                  }}
                />
                {errors.timeOut && (
                  <Alert className="mt-2 p-2" color={'danger'}>
                    {errors.timeOut}
                  </Alert>
                )}
              </FormGroup>
            </Col>

            <Col md={2}>
              <FormGroup>
                <Button
                  color="primary"
                  type="submit"
                  disabled={saving}
                  onClick={this.saveEntry}
                  className="mt-4"
                >
                  {saving ? 'Saving' : 'Save'}
                </Button>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </Col>
    );
  }
}

TimeCardEntryInlineForm.propTypes = {
  cardId: PropTypes.number,
  saveTimeEntry: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(timeCardEntryActions, dispatch),
  };
}

export default withRouter(
  connect(null, mapDispatchToProps)(TimeCardEntryInlineForm)
);



// WEBPACK FOOTER //
// ./src/components/timecard/TimeCardEntryInlineForm.js